import {Component, OnInit, Output, Input, EventEmitter} from '@angular/core';
import {TextRendererComponent} from '../text-renderer/text-renderer.component';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {ColDef, ColGroupDef, GridOptions} from 'ag-grid-community';
import {ShipmentItemService} from '../../../../services/frt-shipment-item/frt-shipment-item.service';
import {FrtPackagesItemsEntity} from 'src/app/shared/common-components/common-structure';
import {FrtItemsMasterEntity} from 'src/app/shared/common-components/common-structure';
import {AlertService} from '../../../../services/alert/alert.service';
import {ConfirmationModalComponent} from 'src/app/shared/common-components/confirmation-modal/confirmation-modal.component';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import {LoadingService} from '../../../../services/loading/loading.service';
import {FrtShipmentPackageService} from '../../../../services/frt-shipment-package/frt-shipment-package.service';
import {UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators} from '@angular/forms';
import {TypeaheadMatch} from 'ngx-bootstrap/typeahead';
import {ActivatedRoute, Router} from '@angular/router';
import {FrtShipmentPackagesEntity} from 'src/app/shared/common-components/common-structure';
import {UserService} from '../../../../services/user/user.service';

@Component({
    selector: 'app-frt-shipment-package-modal',
    templateUrl: './frt-shipment-item-modal.component.html',
    styleUrls: ['./frt-shipment-item-modal.component.css'],
    standalone: false
})
export class FrtShipmentHazmatModalComponent implements OnInit {
  shipmentItemGridOptions: GridOptions = this.initializeGridOptions();
  shipmentPackageGridOptions: GridOptions = this.initializePackageGridOptions();
  shipmentDetailsId: number;
  shipmentPackagesId: number;
  frtShipmentItem: UntypedFormGroup;
  shipmentItemList: any = [];
  shipmentItemListBeforeEditFields: any = [];
  shipmentPackageList: any = [];
  haveRecords = false;
  errorMessage = '';
  public itemModalCalledFrom; // use this field to determine from where the modal window is called.
  modalRef: BsModalRef;
  shipmentItemMasterList: FrtItemsMasterEntity[];
  frtItemsMasterEntity: FrtItemsMasterEntity;
  itemMasterMap: Map<string, FrtItemsMasterEntity> = new Map<string, FrtItemsMasterEntity>();
  dataSourceOrigin: Observable<any>;
  typeaheadOriginLoading: boolean;
  entity: any;
  itemType: string;
  resultsPage: any = null;
  commodity: string;
  frtPackageItemsId: number;
  hazmathIndicator: boolean;
  itemClicked = false;
  @Input() shipmentPackage: FrtShipmentPackagesEntity;
  currentUser: any;
  isCarrierUser: boolean;
  @Output() modalCloseEvent: EventEmitter<any> = new EventEmitter();
  @Input() isUserFromCarrierOrBOL: boolean;
  shipmentPackageColumnDefs: any;

  constructor(private bsModalRef: BsModalRef,
              private shipmentItemService: ShipmentItemService,
              private http: HttpClient,
              private modalService: BsModalService,
              private alertService: AlertService,
              public loader: LoadingService,
              private frtShipmentPackageService: FrtShipmentPackageService,
              private fb: UntypedFormBuilder,
              private route: ActivatedRoute,
              private router: Router,
              private userService: UserService) {

    this.dataSourceOrigin = Observable.create((observer: any) => {
      this.shipmentItemService.getItemTypes(this.frtShipmentItem.get('asyncOriginSearchString').value).subscribe((result: any) => {
        observer.next(result);
        this.loader.hide();
      }, () => {
        this.loader.hide();
      });
    });
  }

  psnAddedColumnDefs = [
    {headerName: 'Item Type/Description', field: 'pkggrp',},
    {headerName: 'Quantity', field: 'labelcodes'},
    {headerName: 'Weight', field: 'tchName'},
    {headerName: 'Other Description', field: 'psn'}

  ];

  packageColumnDefs = [
    {
      headerName: 'Package Selected',
      children: [
        {headerName: 'Total Pieces', field: 'VendorMaintenance'},
        {headerName: 'No. of Loose Pieces', field: 'noOfLoosePieces'},
        {headerName: 'Type', field: 'packageTypeId'}
      ]
    },
    {headerName: 'Fright Commodity Description', field: 'commodityDesc'},
    {headerName: 'WEIGHT(Pounds Only)', field: 'packageWeight'},
    {headerName: 'CUBE', field: 'cubicFeet'},
    {headerName: 'HM', field: 'country'}
  ];

  packageRowData = [
    {}
  ];

  psnColumnDefs = [
    {headerName: 'Item Type/Description *', field: 'labelcodes', editable: true, cellRendererFramework: TextRendererComponent},
    {headerName: 'Quantity', field: 'labelcodes', editable: true, cellRendererFramework: TextRendererComponent},
    {headerName: 'Weight', field: 'tchName', editable: true, cellRendererFramework: TextRendererComponent},
    {headerName: 'Other Description', field: 'psn', editable: true, cellRendererFramework: TextRendererComponent}
  ];

  psnRowData = [{}];

  ngOnInit() {
    this.shipmentDetailsId = this.shipmentPackage.frtShipmentDetailsId;
    this.shipmentPackagesId = this.shipmentPackage.frtShipmentPackagesId;
    this.initializeForm();
    this.getShipmentPackagesListByShipmentPackagesId(this.shipmentPackagesId);
    this.getShipmentItemList(this.shipmentDetailsId, this.shipmentPackagesId);
    this.getItemMasterList();
    this.checkUserRole();
    if (this.isUserFromCarrierOrBOL) {
      this.frtShipmentItem.get('asyncOriginSearchString').disable();
      this.frtShipmentItem.get('itemsQuantity').disable();
      this.frtShipmentItem.get('itemsWeight').disable();
      this.frtShipmentItem.get('otherDescription').disable();
    }
    this.shipmentPackageColumnDefs = this.getShipmentPackageColumnDefs();
  }

  checkUserRole() {
    // Get the current user.
    this.currentUser = this.userService.getUserDetails().subscribe(user => {
      this.currentUser = user;
      if (user && user.roles) {
        for (const role of user.roles) {
          if (role.name === 'Carrier User' || role.name === 'Carrier User Admin' || role.name === 'Carrier User RF') {
            this.isCarrierUser = true;
            break;
          } else {
            this.isCarrierUser = false;
          }
        }
      }
    });
  }

  getItemMasterList() {
    this.shipmentItemService.getItemMasterList()
      .subscribe(data => {
          if (data) {
            this.shipmentItemMasterList = data;
            this.itemMasterMap = new Map<string, FrtItemsMasterEntity>();
            const totalItems = this.shipmentItemList.length;
            for (const shipmentItemMaster of this.shipmentItemMasterList) {
              this.itemMasterMap.set(shipmentItemMaster.itemNumber, shipmentItemMaster);
            }
          }
        }, (error) => {
          this.alertService.error('There was an error retrieving Shipment Review records');
        }
      );
  }

  getShipmentPackagesByShipmentDetailsId(shipmentDetailsId: number) {
    this.frtShipmentPackageService.getShipmentPackagesByShipmentDetailsId(shipmentDetailsId)
      .subscribe(data => {
          if (data) {
            this.shipmentPackageList = data;
          }

        }, (error) => {
          this.alertService.error('There was an error retrieving frt Shipment Package records');
        }
      );
  }

  getShipmentPackagesListByShipmentPackagesId(shipmentPackagesId: number) {
    this.frtShipmentPackageService.getShipmentPackagesByShipmentPackagesId(shipmentPackagesId)
      .subscribe(data => {
          if (data) {
            if (data && data.length > 0) {
              for (const d of data) {
                if (d.hazmatIndicator === 0) {
                  d.hazmathIndOnScreen = 'N';
                } else {
                  d.hazmathIndOnScreen = 'Y';
                }
              }
            }
            this.shipmentPackageList = data;
          }
        }, (error) => {
          this.alertService.error('There was an error retrieving frt Shipment Package records');
        }
      );
  }

  // Get the Shipment Package items records for a provided shipmentDetailsId and shipmentPackagesId
  getShipmentItemList(shipmentDetailsId: number, shipmentPackagesId: number) {
    this.shipmentItemService.getShipmentItemListByPackageType(shipmentDetailsId, shipmentPackagesId)
      .subscribe(data => {
        if (data) {
          this.shipmentItemListBeforeEditFields = data;
          this.shipmentItemList = data;
          if (this.shipmentItemListBeforeEditFields.length === 0) {
            this.errorMessage = 'No records found for the search criteria!!!!!! ';
          }
        }
        // this.tmssloader.hide();
      }, (error) => {
        //  this.tmssloader.hide();
        console.log('There was an error retrieving Shipment Items records');
        this.alertService.error('There was an error retrieving Shipment Items records');
      });
  }

  reset() {
    this.frtShipmentItem.controls.itemsQuantity.setValue(null);
    this.frtShipmentItem.controls.itemsWeight.setValue(null);
    this.frtShipmentItem.controls.otherDescription.setValue(null);
    this.frtShipmentItem.controls.asyncOriginSearchString.setValue(null);
    this.itemClicked = false;
  }

  addItems() {
    this.itemType = this.frtShipmentItem.get('itemNumber').value as string;
    const frtPackagesItemsEntity = new FrtPackagesItemsEntity();
    this.frtItemsMasterEntity = this.itemMasterMap.get(this.itemType + '');
    this.commodity = this.frtItemsMasterEntity.commodity;
    frtPackagesItemsEntity.frtShipmentDetailsId = this.shipmentPackage.frtShipmentDetailsId;
    frtPackagesItemsEntity.frtShipmentPackagesId = this.shipmentPackage.frtShipmentPackagesId;
    frtPackagesItemsEntity.frtItemsMasterId = this.frtItemsMasterEntity.frtItemsMasterId;
    frtPackagesItemsEntity.itemsQuantity = this.frtShipmentItem.get('itemsQuantity').value;
    frtPackagesItemsEntity.itemsWeight = this.frtShipmentItem.get('itemsWeight').value;
    frtPackagesItemsEntity.otherDescription = this.frtShipmentItem.get('otherDescription').value;
    this.createUser(frtPackagesItemsEntity)
      .subscribe
      (data => {
          if (!(data == null)) {
            if (this.commodity === 'HAZD') {
              if (this.shipmentPackage.hazmatIndicator) {
                console.log('Package is already Hazmath');
              } else {
                this.shipmentPackage.hazmatIndicator = 1;
                this.frtShipmentPackageService.updateShipmentPackageEntity(this.shipmentPackage)
                  .subscribe(flagResult => {
                    if (flagResult.hazmatIndicator === 1) {
                      this.getShipmentPackagesListByShipmentPackagesId(this.shipmentPackage.frtShipmentPackagesId);
                    }
                  });
              }
            }
            this.alertService.success('Item has been added Successfully');
            // this.getShipmentPackagesListByShipmentPackagesId(this.shipmentPackage.frtShipmentPackagesId);
            this.getShipmentItemList(this.shipmentPackage.frtShipmentDetailsId, this.shipmentPackage.frtShipmentPackagesId);
            this.reset();
          } else {
            console.log('Error createUser data');
          }
        },
        err => {
          console.log('Error createUser data=', err);
        });
    this.getShipmentPackagesListByShipmentPackagesId(this.shipmentPackage.frtShipmentPackagesId);
    this.getShipmentItemList(this.shipmentDetailsId, this.shipmentPackagesId);
  }

  createUser(frtPackagesItemsEntity: FrtPackagesItemsEntity): Observable<any> {
    return this.http
      .put('/tmssserver/api/frtpackageitems/update', frtPackagesItemsEntity);
  }

  updateItem() {
    this.itemType = this.frtShipmentItem.get('itemNumber').value as string;
    console.log('Map Values is : ' + this.itemMasterMap.get(this.itemType + '').itemNumber);

    const frtPackagesItemsEntity = new FrtPackagesItemsEntity();
    this.frtItemsMasterEntity = this.itemMasterMap.get(this.itemType + '');
    this.commodity = this.frtItemsMasterEntity.commodity;
    frtPackagesItemsEntity.frtShipmentDetailsId = this.shipmentPackage.frtShipmentDetailsId;
    frtPackagesItemsEntity.frtShipmentPackagesId = this.shipmentPackage.frtShipmentPackagesId;
    frtPackagesItemsEntity.frtItemsMasterId = this.frtItemsMasterEntity.frtItemsMasterId;
    frtPackagesItemsEntity.itemsQuantity = this.frtShipmentItem.get('itemsQuantity').value;
    frtPackagesItemsEntity.itemsWeight = this.frtShipmentItem.get('itemsWeight').value;
    frtPackagesItemsEntity.otherDescription = this.frtShipmentItem.get('otherDescription').value;
    if (this.frtPackageItemsId != null) {
      frtPackagesItemsEntity.frtPackageItemsId = this.frtPackageItemsId;
    }
    this.createUser(frtPackagesItemsEntity)
      .subscribe
      (data => {
          if (!(data == null)) {
            this.alertService.success('Item has been updated Successfully');
            this.getShipmentItemList(this.shipmentPackage.frtShipmentDetailsId, this.shipmentPackage.frtShipmentPackagesId);
          } else {
            console.log('Error createUser data');
          }
        },
        err => {
          console.log('Error createUser data=', err);
        });
    this.getShipmentItemList(this.shipmentDetailsId, this.shipmentPackagesId);
  }

  deleteItem() {
    this.modalRef = this.modalService.show(ConfirmationModalComponent);
    this.modalRef.content.question = 'Are you Sure, Do You Want to Delete this Item';
    this.modalRef.content.title = 'Deleting Item ';
    this.modalRef.content.confirmText = 'Yes';
    this.modalRef.content.cancelText = 'No';
    this.modalRef.content.emitData.subscribe(result => {
      if (result.obj === true) {
        this.loader.show();
        this.shipmentItemService.deletePackageItem(this.frtPackageItemsId).subscribe(() => {
          this.alertService.success('Successfully Deleted Item');
          this.getShipmentItemList(this.shipmentDetailsId, this.shipmentPackagesId);
          this.loader.hide();
          setTimeout(() => {
            if (this.shipmentItemList.length > 0) {
              for (const shipmentItem of this.shipmentItemList) {
                if (shipmentItem.frtItemsMasterEntity.commodity === 'HAZD') {
                  this.hazmathIndicator = true;
                  break;
                } else {
                  this.hazmathIndicator = false;
                }
              }
            } else {
              this.hazmathIndicator = false;
            }
            if (this.hazmathIndicator) {
              if (this.shipmentPackageList.get(0).hazmathIndicator) {
              } else {
                this.shipmentPackageList.get(0).hazmathIndicator = true;
                this.frtShipmentPackageService.updateShipmentPackageEntity(this.shipmentPackageList.get(0))
                  .subscribe(flagResult => {
                    if (result.obj === true) {
                      console.log('Updated the Hazmath Indicator');
                    }
                    this.getShipmentPackagesListByShipmentPackagesId(this.shipmentPackage.frtShipmentPackagesId);
                    this.reset();
                  });
              }
            } else {
              this.shipmentPackage.hazmatIndicator = 0;
              this.frtShipmentPackageService.updateShipmentPackageEntity(this.shipmentPackage)
                .subscribe(flagResult => {
                  if (result.obj === true) {
                    console.log('Updated the Hazmath Indicator');
                  }
                  this.getShipmentPackagesListByShipmentPackagesId(this.shipmentPackage.frtShipmentPackagesId);
                  this.reset();
                });
            }
          }, 4000);

        }, error => {
          this.loader.hide();
          this.alertService.error('There was an error deleting Item');
        });
        // this.getShipmentPackagesListByShipmentPackagesId(this.shipmentPackage.frtShipmentPackagesId);
      }
    });
    
  }

  changeTypeaheadOriginLoading(e: boolean): void {
    this.typeaheadOriginLoading = e;
  }

  typeaheadOriginOnSelect(e: TypeaheadMatch): void {
    const itemno = e;
    this.frtShipmentItem.get('itemNumber').setValue(e.item.itemNumber);
  }

  initializeForm() {
    this.frtShipmentItem = this.fb.group({
      asyncOriginSearchString: new UntypedFormControl(null, []),
      frtShipmentDetailsId: new UntypedFormControl(''),
      frtShipmentPackagesId: new UntypedFormControl(''),
      itemNumber: new UntypedFormControl('', [Validators.required]),
      itemsQuantity: new UntypedFormControl('', [Validators.maxLength(5)]),
      itemsWeight: new UntypedFormControl('', [Validators.maxLength(5)]),
      otherDescription: new UntypedFormControl(''),
      agencyMasterId: new UntypedFormControl(''),
      description: new UntypedFormControl(''),
      commodity: new UntypedFormControl('')
    });
  }

  closeModal() {
    this.modalCloseEvent.emit('reload');
    this.bsModalRef.hide();
  }

  private initializePackageGridOptions() {
    return <GridOptions>{
      columnDefs: this.getShipmentPackageColumnDefs(),
      rowSelection: 'multiple',
      defaultColDef: {
        sortable: true,
        resizable: true,
        filter: 'agNumberColumnFilter',
        filterParams: {
          suppressAndOrCondition: true
        }
      },
      headerHeight: 25,
      pagination: true,
      paginationPageSize: 25,
      cacheBlockSize: 25,
      onGridReady: params => {
        params.api.sizeColumnsToFit();
      },
      overlayLoadingTemplate:
        '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>',
      overlayNoRowsTemplate:
        '<span>No results found. Please adjust your filters.</span>'
    };
  }

  private initializeGridOptions() {
    return <GridOptions>{
      columnDefs: this.getShipmentItemColumnDefs(),
      rowSelection: 'multiple',
      defaultColDef: {
        sortable: true,
        resizable: true,
        filter: 'agNumberColumnFilter',
        filterParams: {
          suppressAndOrCondition: true
        }
      },
      headerHeight: 25,
      pagination: true,
      paginationPageSize: 25,
      cacheBlockSize: 25,

      onGridReady: params => {
        params.api.sizeColumnsToFit();
      },
      overlayLoadingTemplate:
        '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>',
      overlayNoRowsTemplate:
        '<span>No results found. Please adjust your filters.</span>'
    };
  }

  onItemTypeClicked(shipmentReviewListSelectedItem: any) {
    this.frtPackageItemsId = shipmentReviewListSelectedItem.frtPackageItemsId;
    this.frtShipmentItem.get('asyncOriginSearchString').setValue(shipmentReviewListSelectedItem.frtItemsMasterEntity.itemNumber);
    this.frtShipmentItem.get('frtShipmentDetailsId').setValue(shipmentReviewListSelectedItem.frtItemsMasterEntity.frtShipmentDetailsId);
    this.frtShipmentItem.get('frtShipmentPackagesId').setValue(shipmentReviewListSelectedItem.frtItemsMasterEntity.frtShipmentPackagesId);
    this.frtShipmentItem.get('itemNumber').setValue(shipmentReviewListSelectedItem.frtItemsMasterEntity.itemNumber);
    this.frtShipmentItem.get('itemsQuantity').setValue(shipmentReviewListSelectedItem.itemsQuantity);
    this.frtShipmentItem.get('itemsWeight').setValue(shipmentReviewListSelectedItem.itemsWeight);
    this.frtShipmentItem.get('otherDescription').setValue(shipmentReviewListSelectedItem.otherDescription);
    this.frtShipmentItem.get('description').setValue(shipmentReviewListSelectedItem.frtItemsMasterEntity.description);
    this.itemClicked = true;
  }

  getShipmentPackageColumnDefs(): (ColDef | ColGroupDef)[] {
    return [
      <ColDef>
        {
          headerName: 'Package Selected',
          children: [
            {colId: 'Total Pieces', field: 'totalPieces'},
            {colId: 'No. of Loose Pieces', field: 'noOfLoosePieces'},
            {colId: 'Type', field: 'packageTypeId'}
          ]
        },
      {headerName: 'Fright Commodity Description', field: 'commodityDesc'},
      {headerName: 'WEIGHT(Pounds Only)', field: 'packageWeight'},
      {headerName: 'CUBE', field: 'cubicFeet'},
      {headerName: 'HM', field: 'hazmatIndicator'}

    ];
  }

  getShipmentItemColumnDefs(): (ColDef | ColGroupDef)[] {
    return [
      <ColDef>
        {
          headerName: 'Item Type',
          field: 'frtItemsMasterEntity.itemNumber',
          cellRenderer: params =>
            params.data ? '<a tabindex="0">' + params.data.frtItemsMasterEntity.itemNumber + '</a>' : '',
          onCellClicked: event => this.onItemTypeClicked(event.data)
        },
      {
        headerName: 'Description',
        field: 'frtItemsMasterEntity.description'
      },
      {
        headerName: 'Quantity',
        field: 'itemsQuantity'
      },
      {
        headerName: 'Weight',
        field: 'itemsWeight',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Other Description',
        field: 'otherDescription',
        filter: 'agTextColumnFilter'
      }

    ];
  }
}
